module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "private-area",
    class: {
      'has-sidebar': _vm.sidebarOpened
    }
  }, [_c('sidebar', {
    attrs: {
      "show": _vm.sidebarOpened
    },
    on: {
      "showDashboardModal": _vm.openDashboardModal
    }
  }), _vm._v(" "), _c('router-view', {
    staticClass: "router-view"
  }), _vm._v(" "), (_vm.showDashboardModal) ? _c('dashboard-modal', {
    on: {
      "save": _vm.connectDashboardSave,
      "close": _vm.closeDashboardModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65b6cd4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/index.vue
// module id = 656
// module chunks = 0